import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Card, Typography, Grid, Button } from '@hbf/dsl';
import { useIntl } from 'ha/i18n';
import { useMediaQuery } from 'ha/helpers/MediaQuery';

const useStyles = makeStyles()(theme => ({
  card: {
    backgroundColor: '#0C327C',
    borderRadius: '10px',
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    padding: theme.spacing(1.5),

    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(3),
      padding: theme.spacing(3),
    },
  },
  hashtag: {
    color: '#EED348',
    lineHeight: 1.5,
    [theme.breakpoints.up('md')]: {
      fontSize: '1.875rem',
    },
  },
  text: {
    [theme.breakpoints.up('md')]: {
      fontSize: '1.125rem',
    },
  },
  noShrink: {
    flexShrink: 0,
  },
  buttonContainer: {
    flexGrow: 1,
    flexShrink: 0,
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(1),
      flexBasis: 0,
    },
  },
  button: {
    backgroundColor: '#FAD649',
    color: 'inherit',
    [theme.breakpoints.up('md')]: {
      minWidth: '10rem',
    },
    '&:hover': {
      backgroundColor: '#AF9533',
    },
  },
}));

export const UkraineBanner: React.FC = () => {
  const { classes } = useStyles();
  const { T, urlResolver } = useIntl();
  const { md } = useMediaQuery();

  return (
    <Card className={classes.card} elevation={0}>
      <Grid
        container
        spacing={md ? 2 : 0}
        justifyContent="space-between"
        alignItems="center"
        wrap={md ? 'nowrap' : 'wrap'}
      >
        <Grid item xs={12} md="auto">
          <Typography.H2 className={classes.hashtag} textTransform="uppercase">
            {T('ukr_response.hashtag_support_ukrainen')}
          </Typography.H2>
        </Grid>
        <Grid item xs={12} md>
          <Typography.Caption color="white" className={classes.text}>
            {T('ukr_response.banner.text')}
          </Typography.Caption>
        </Grid>
        <Grid item xs={12} md="auto" className={classes.noShrink}>
          <Grid container spacing={2} wrap="nowrap">
            <Grid item className={classes.buttonContainer}>
              <Button
                size={md ? 'large' : 'small'}
                disableElevation
                className={classes.button}
                fullWidth={!md}
                href={urlResolver.getSupportUkraineUrl()}
                variant="contained"
              >
                {T('cta.offer_stay')}
              </Button>
            </Grid>
            <Grid item className={classes.buttonContainer}>
              <Button
                size={md ? 'large' : 'small'}
                disableElevation
                className={classes.button}
                fullWidth={!md}
                href={urlResolver.getSearchUkraineUrl()}
                variant="contained"
              >
                {T('cta.look_stay')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};
